import { NavigationDrawer } from "./NavigationDrawer";
import { AppBar, Box, Chip, Toolbar } from "@mui/material";
import { ReactNode } from "react";
import { useMenuData } from "../menu-provider/MenuDataProvider";

const MenuNameChip = () => {
  const { restaurantName } = useMenuData();
  if (!restaurantName) return null;

  return (
    <Chip
      label={restaurantName}
      size="small"
      sx={{
        ml: 1.5,
        fontWeight: 600,
        fontSize: "0.75rem",
        bgcolor: "rgba(25, 118, 210, 0.08)",
        color: "primary.main",
        border: "1px solid rgba(25, 118, 210, 0.2)",
        height: 24,
      }}
    />
  );
};

export const DashboardHeader = ({ rightBar }: { rightBar?: ReactNode }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{ backgroundColor: "rgba(83, 83, 83, 0.06)" }}
      >
        <Toolbar variant="dense">
          <NavigationDrawer />
          <MenuNameChip />
          <Box flexGrow={1} />
          {rightBar}
        </Toolbar>
      </AppBar>
    </Box>
  );
};
